import request from "./axios";
import common from "../utils/common";

export default {
  startTest(type, project_id, env, data = {}, urlReplace) {
    let url;
    if (env === "prod") {
      url = "coding.jiker.com";
    } else {
      url = "uat-coding.jiker.vip";
    }
    
    const requestURL = (() => {
      if (urlReplace) {
        const config = { 
          host: `${url}`,
          path: '/api/v1/execute/doExec',
          type: encodeURIComponent(type) 
        };
        if (project_id) {
          config.project_id = project_id
        }
        return common.assembleUrlQuery('/', config);
      }
      if (project_id) {
        data.project_id = project_id;
        data.code_name = type;
        data.variableType = 'single'
      } else {
        data.code_name = type;
        data.variableType = 'single'
      }
      return `https://${url}/api/v1/execute/doExec`;
    })();
    return request.post(requestURL, data, {
      urlReplace: urlReplace
    });
  }
};
